import { entrypoints } from '../../appConfig/entrypoints'

export const entrypointExists = (entrypoint: string) => Object.keys(entrypoints).includes(entrypoint)
